import { PlayerLeague } from '@pff-consumer/schema'

export const isNcaa = (league: PlayerLeague) => {
  return league.toLowerCase() === PlayerLeague.NCAA
}

export const isNfl = (league: PlayerLeague) => {
  return league.toLowerCase() === PlayerLeague.NFL
}
